import { useQuery, gql } from '@apollo/client';

export const useGetAliquotas = () => {
  const query = gql`
    query {
      simulador {
        faixaInss {
          valor
          calculo
          subtracao
        }
        faixaIrrf {
          nome
          valor
          calculo
          subtracao
        }
        tetoInss {
          dataInicio
          valor
        }
      }
    }
  `;

  return useQuery(query);
};

export default useGetAliquotas;
